import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const NewsPage = lazy(() => import('./index.js'));

function NewsPageLazy(props) {
    return (
        <Suspense fallback={<Loader/>}>
            <NewsPage {...props} />
        </Suspense>
    );
}

export default NewsPageLazy;
export { NewsPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/news-page/lazy.js